"use strict";
define(
    'stores/buncees',[
        "jquery",
        "stores/store",
        "actions/buncees",
        "constants/actiontypes"
    ],
    function ($, StoreBase, Action, Constants)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;

        function Store (params)
        {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.buncees = {};
            this.bunceesByOwner = {};

            this.registerDispatchListener(function (action) {
                switch(action.actionType) {
                    case Constants.CREATED_BUNCEE:
                        if (Array.isArray(action.data)) {
                            _.each(action.data, function (data, index, list) {
                                this.addBuncee(data);
                            }, this);
                        } else {
                            this.addBuncee(action.data);
                        }
                        this.event.emit("change");
                        break;
                    case Constants.DELETED_BUNCEE:
                        // debugger;
                        this.removeBuncee(action.guid);
                        this.event.emit("change");
                        break;
                }
            }.bind(this));

            this.action = new Action();
        }

        Store.prototype.pull = function(bunceeGuid, accessOption) {
            if(!bunceeGuid) {
                return;
            }

            if(!this.buncees[bunceeGuid]) {
                this.action.pull(bunceeGuid, accessOption);
            }
        }

        Store.prototype.pullByOwner = function(ownerGuid, onComplete) {
            var self = this;

            if(!ownerGuid) {
                return;
            }

            if(!this.bunceesByOwner[ownerGuid]) {
                this.bunceesByOwner[ownerGuid] = "pulling";

                this.action.pull(null, {user_guid: ownerGuid}, function() {
                    // setting up bunceesByOwner;
                    var filtered = {};
                    _.each(self.buncees, function(buncee) {
                        if(buncee.owner_guid.toLowerCase() == ownerGuid) {
                            filtered[buncee.id] = buncee;
                        }
                    });
                    self.bunceesByOwner[ownerGuid] = filtered;
                    onComplete();
                });
            }
            else if(typeof this.bunceesByOwner[ownerGuid] == "object") {
                onComplete();
            }
        }

        Store.prototype.addBuncee = function(data)
        {
            data.created_at = new Date(data.created_at);
            data.updated_at = new Date(data.updated_at);
            if(this.buncees[data.id.toLowerCase()]) {   
                Object.assign(this.buncees[data.id.toLowerCase()], data);
            } else {
                this.buncees[data.id.toLowerCase()] = data;
            }
            
        };

        Store.prototype.removeBuncee = function(guid) 
        {
            if(this.hasBuncee(guid)) {
                var buncee = this.buncees[guid.toLowerCase()];
                delete this.buncees[guid.toLowerCase()];
                if(this.bunceesByOwner[buncee.owner_guid] !== undefined) {
                    delete this.bunceesByOwner[buncee.owner_guid][guid];
                }
            }
        }

        Store.prototype.getAllBuncees = function()
        {
            return this.buncees;
        };

        Store.prototype.getAllMyBuncees = function()
        {
            var myGuid = appData.user.guid.toLowerCase();
            
            var filtered = {};
            _.each(this.buncees, function(buncee) {
                if(buncee.owner_guid.toLowerCase() == myGuid) {
                    filtered[buncee.id] = buncee;
                }
            });
            return filtered;
        };

        Store.prototype.hasBuncee = function(id)
        {
            return (id.toLowerCase() in this.buncees);
        };

        Store.prototype.getBuncee = function(id)
        {
            if(id && this.buncees[id.toLowerCase()])
                return this.buncees[id.toLowerCase()];
            return null;
        };

        Store.prototype.getBuncees = function(ids)
        {
            var filtered = {};
            for(var i = 0; i < ids.length; i++) {
                if(this.buncees[ids[i].toLowerCase()]) {
                    filtered[ids[i]] = this.buncees[ids[i].toLowerCase()];
                }
            }

            return filtered;
        };

        Store.prototype.clearSectionCache = function(sectionId){
            delete this.sectionCache[sectionId];
        };

        Store.prototype.filterByOwner = function (ownerId)
        {
            var filtered = [];
            _.each(this.buncees, function (item, index, list)
            {
                if(item.owner_guid == ownerId)
                    filtered.push(item);
            }, this);

            return filtered;
        }

        Store.prototype.filterByOwners = function (ownerIds)
        {
            var self = this;
            var filtered = [];
            _.each(ownerIds, function(ownerId) {
                _.each(self.buncees, function (item, index, list)
                {
                    if(item.owner_guid == ownerId)
                        filtered.push(item);
                }, this);
            });

            return filtered;
        }

        return Store;
    });

